module.exports = __webpack_public_path__ + "img/warsztaty-1.6c19b39c.jpg";